import * as tslib_1 from "tslib";
import { LayerApi } from '../api/layer-api';
import { ESRI } from '../esri-loader-util';
import { isClassBreaksRenderer, isSimpleRenderer, isSymbolWithStyle, isUniqueValueRenderer } from '../types';
import { LegendService } from './legend.service';
import * as i0 from "@angular/core";
import * as i1 from "../api/layer-api";
import * as i2 from "./legend.service";
var SplitThemeService = /** @class */ (function () {
    function SplitThemeService(layerApi, legendService) {
        this.layerApi = layerApi;
        this.legendService = legendService;
        this.minMaxes = {
            'unique-value': {
                min: 2,
                max: 100
            },
            'class-break': {
                min: 3,
                max: 25
            }
        };
    }
    SplitThemeService.prototype.getLayerColumnsFromLayer = function (layer) {
        var retVal;
        if (layer && layer.mapcoreProps && layer.mapcoreProps.columns && layer.mapcoreProps.columns.length) {
            retVal = layer.mapcoreProps.columns
                .map(function (c) { return ({ name: c.name, alias: c.alias }); })
                .sort(function (a, b) {
                return a.alias.localeCompare(b.alias, 'en', { sensitivity: 'base', numeric: true });
            });
        }
        return retVal;
    };
    SplitThemeService.prototype.getLayerClassBreakData = function (layerId, fieldName, numSelectedClasses, forceUniqueValues, query, columnIsDate, classBreakLabels) {
        if (columnIsDate === void 0) { columnIsDate = false; }
        if (classBreakLabels === void 0) { classBreakLabels = '[]'; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var retVal, results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerApi.getClassBreakData(layerId, [fieldName], numSelectedClasses, forceUniqueValues, query, columnIsDate, classBreakLabels)];
                    case 1:
                        results = _a.sent();
                        if (results && results.length) {
                            retVal = results[0].classBreakData;
                        }
                        return [2 /*return*/, retVal];
                }
            });
        });
    };
    SplitThemeService.prototype.getSimpleLayerSymbols = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var symbols, i, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        symbols = [];
                        i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(i < layer.sublayers.length)) return [3 /*break*/, 4];
                        _b = (_a = symbols).push;
                        return [4 /*yield*/, this.getSimpleSublayerSymbol(layer, i)];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, symbols];
                }
            });
        });
    };
    SplitThemeService.prototype.getSimpleSublayerSymbol = function (layer, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var symbol, r;
            return tslib_1.__generator(this, function (_a) {
                r = layer.sublayers.getItemAt(index).renderer;
                if (isSimpleRenderer(r)) {
                    symbol = r.symbol;
                }
                else if (isClassBreaksRenderer(r)) {
                    symbol = r.classBreakInfos[0].symbol;
                }
                else if (isUniqueValueRenderer(r)) {
                    symbol = r.uniqueValueInfos[0].symbol;
                }
                else if (layer.mapcoreProps.simpleRenderers) {
                    symbol = layer.mapcoreProps.simpleRenderers[index].symbol;
                }
                return [2 /*return*/, symbol];
            });
        });
    };
    SplitThemeService.prototype.getClassColors = function (count, currentColors, symbol, useSymbolScheme, useEsriScheme) {
        if (useSymbolScheme === void 0) { useSymbolScheme = false; }
        if (useEsriScheme === void 0) { useEsriScheme = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var colors, _a, Color, SymbologyColor, scheme, tenBase, fiveBase, defaultFillOpacity, esriColors_1, i, defaultColors, i;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        colors = [];
                        return [4 /*yield*/, Promise.all([ESRI.Color, ESRI.SymbologyColor])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), Color = _a[0], SymbologyColor = _a[1];
                        scheme = SymbologyColor.getSchemes({ geometryType: 'polyline', basemap: this.mapView.map.basemap, theme: 'high-to-low' });
                        tenBase = 10;
                        fiveBase = 5;
                        defaultFillOpacity = 0.5;
                        if (!(symbol && (symbol.type === 'simple-fill' || useSymbolScheme) && (!isSymbolWithStyle(symbol) || (isSymbolWithStyle(symbol) && symbol.style !== 'none')) && this.getOpacity(symbol.color) !== 0)) return [3 /*break*/, 5];
                        if (!(currentColors && currentColors.length && currentColors.length === count)) return [3 /*break*/, 2];
                        colors = currentColors;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getColorGradient(symbol.color, count)];
                    case 3:
                        colors = _b.sent();
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        if (useEsriScheme) {
                            esriColors_1 = [];
                            scheme.primaryScheme.colorsForClassBreaks.filter(function (x) { return x.numClasses === tenBase; })[0].colors.forEach(function (breakColor) {
                                esriColors_1.push(breakColor);
                            });
                            scheme.secondarySchemes[0].colorsForClassBreaks.filter(function (x) { return x.numClasses === tenBase; })[0].colors.forEach(function (breakColor) {
                                esriColors_1.push(breakColor);
                            });
                            scheme.secondarySchemes[1].colorsForClassBreaks.filter(function (x) { return x.numClasses === fiveBase; })[0].colors.forEach(function (breakColor) {
                                esriColors_1.push(breakColor);
                            });
                            if (symbol.type === 'simple-fill') {
                                esriColors_1.forEach(function (c) { return c.a = defaultFillOpacity; });
                            }
                            for (i = 0; i < this.minMaxes['unique-value'].max; i++) {
                                colors.push(currentColors && currentColors.length > i ? currentColors[i] : esriColors_1[i]);
                            }
                        }
                        else {
                            defaultColors = this.legendService.getDefaultColors();
                            for (i = 0; i < this.minMaxes['unique-value'].max; i++) {
                                if (defaultColors.length > i) {
                                    colors.push(Color.fromArray(defaultColors[i]));
                                }
                                else {
                                    colors.push(Color.fromArray(this.legendService.getRandomColorRGB()));
                                }
                            }
                            if (symbol.type === 'simple-fill') {
                                colors.forEach(function (c) { return c.a = defaultFillOpacity; });
                            }
                        }
                        _b.label = 6;
                    case 6: return [2 /*return*/, [colors, scheme]];
                }
            });
        });
    };
    SplitThemeService.prototype.getColorGradient = function (baseColor, length) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var Color, minOpacity, color, direction, avoidTooDarkOrLight, deltas, colors;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Color];
                    case 1:
                        Color = _a.sent();
                        minOpacity = 0.05;
                        color = Array.isArray(baseColor) ? baseColor : baseColor.toRgba();
                        direction = Math.max(color[0], color[1], color[2]) > 127 ? -1 : 1;
                        avoidTooDarkOrLight = 1.5;
                        deltas = color.map(function (h) {
                            var startPoint = direction === 1 ? 255 - h : h;
                            return Math.floor(startPoint / (length * avoidTooDarkOrLight) * direction);
                        });
                        colors = Array.from({ length: length }, function (_, i) {
                            return new Color([
                                color[0] + deltas[0] * i,
                                color[1] + deltas[1] * i,
                                color[2] + deltas[2] * i,
                                Math.max(color[3], minOpacity)
                            ]);
                        });
                        return [2 /*return*/, direction === 1 ? colors.reverse() : colors];
                }
            });
        });
    };
    SplitThemeService.prototype.getOpacity = function (color) {
        return Array.isArray(color) ? color[3] : color.a;
    };
    SplitThemeService.prototype.validateClassBreakCount = function (rendererType, classBreaks) {
        var classBreakLimits = this.minMaxes[rendererType];
        if (classBreaks < classBreakLimits.min) {
            return "This field has fewer than " + classBreakLimits.min + " class breaks. Please try changing the layer filter or selecting a different field.";
        }
        else if (classBreaks > classBreakLimits.max) {
            return "This field has more than " + classBreakLimits.max + " class breaks. Please try filtering the layer or selecting a different field.";
        }
    };
    /**
     * Strips layer references and column metadata from the theme for saving.
     * @param theme The theme to modify.
     * @returns A stripped copy of the theme.
     */
    SplitThemeService.prototype.getThemeForSave = function (theme) {
        return tslib_1.__assign({}, theme, { layerColumns: null, groupLayer: null, classBreaks: theme.classBreaks.map(function (cb) { return (tslib_1.__assign({}, cb, { layer: null })); }) });
    };
    /**
     * Adds data back into the theme that was stripped before saving.
     * @param groupLayer The group layer containing the theme.
     */
    SplitThemeService.prototype.rehydrateTheme = function (groupLayer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, JsonUtils, theme, _loop_1, _b, _c, classBreak;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, ESRI.JsonUtils];
                    case 1:
                        JsonUtils = _d.sent();
                        theme = groupLayer.mapcoreProps.splitTheme;
                        theme.groupLayer = groupLayer;
                        theme.layerColumns = this.getLayerColumnsFromLayer(groupLayer.layers.getItemAt(0));
                        theme.baseSymbols = theme.baseSymbols.map(function (bs) { return JsonUtils.fromJSON(bs); });
                        _loop_1 = function (classBreak) {
                            classBreak.layer = groupLayer.layers.find(function (l) { return l.mapcoreProps.splitThemeLabel === classBreak.info.label; });
                            classBreak.symbols = classBreak.symbols.map(function (sym) { return JsonUtils.fromJSON(sym); });
                        };
                        try {
                            for (_b = tslib_1.__values(theme.classBreaks), _c = _b.next(); !_c.done; _c = _b.next()) {
                                classBreak = _c.value;
                                _loop_1(classBreak);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SplitThemeService.ngInjectableDef = i0.defineInjectable({ factory: function SplitThemeService_Factory() { return new SplitThemeService(i0.inject(i1.LayerApi), i0.inject(i2.LegendService)); }, token: SplitThemeService, providedIn: "root" });
    return SplitThemeService;
}());
export { SplitThemeService };
